import * as React from 'react';
import { Switch } from '@gandi/ui';
import FormGroup from '../decorators/FormGroup';
import FormField from '../wrappers/FormField';
import decorateControl from '../wrappers/decorateControl';
import { jsx as _jsx } from "react/jsx-runtime";
/* Handle compatibility with redux-form:
 * FormField receives it's value as `value: boolean`
 * `Switch` component expects `checked: boolean`.
 */
function SwitchCompat(_props) {
  const {
    isField,
    value,
    ...props
  } = _props;
  const compatProps = {};
  if (typeof value === 'boolean' && !('checked' in props)) {
    // $FlowFixMe[prop-missing]
    compatProps.checked = value;
  }
  // $FlowFixMe[incompatible-type]
  return /*#__PURE__*/_jsx(Switch, {
    ...props,
    ...compatProps
  });
}
const component = decorateControl(SwitchCompat, FormGroup);
const SwitchField = props => /*#__PURE__*/_jsx(FormField, {
  ...props,
  component: component
});
export default SwitchField;